/**
 * Конфигурация API для Jataka Calculator
 *
 * NOTE: baseUrl настраивается в services/api.ts (Axios instance)
 * Здесь используется только для timeout и logging настроек
 */

import { ApiConfig } from '../models/api';

/**
 * Конфигурация для разработки
 */
export const DEVELOPMENT_API_CONFIG: ApiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8027',
  timeout: 15000, // 15 seconds для расчетов
  retries: 3,
  enableLogging: true
};

/**
 * Конфигурация для продакшн
 */
export const PRODUCTION_API_CONFIG: ApiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || 'https://api.bhriguhora.com',
  timeout: 30000, // 30 seconds для продакшн
  retries: 5,
  enableLogging: false
};

/**
 * Получение конфигурации API в зависимости от окружения
 */
export function getApiConfig(): ApiConfig {
  const isDevelopment = process.env.NODE_ENV === 'development';
  return isDevelopment ? DEVELOPMENT_API_CONFIG : PRODUCTION_API_CONFIG;
}

/**
 * Настройка глобального API сервиса с правильной конфигурацией
 */
export function setupApiService() {
  const config = getApiConfig();
  
  // Импортируем и настраиваем сервис
  import('../services/JatakaApiService').then(({ jatakaApiService }) => {
    jatakaApiService.updateConfig(config);
    
    // if (config.enableLogging) {
    // }
  });
}

// Автоматическая настройка при импорте модуля
setupApiService();